/**
 * Lets any screen hand a question to the docked Ask Claude panel: the panel opens (if collapsed)
 * and sends the prompt with its own screen context. A DOM event keeps the screens decoupled from
 * the panel's state; when no panel is mounted (feature off, user not allowed) nothing happens.
 */
export const ASK_ASSISTANT_EVENT = "gw-assistant-ask";

export interface AskAssistantDetail {
  prompt: string;
}

export function askAssistant(prompt: string): void {
  window.dispatchEvent(new CustomEvent<AskAssistantDetail>(ASK_ASSISTANT_EVENT, { detail: { prompt } }));
}
